"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableRow = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable indent */
// External
var StyledTableRow = _styledComponents.default.div.withConfig({
  displayName: "TableRowstyles__StyledTableRow",
  componentId: "sc-16nj870-0"
})(["width:100%;display:flex;flex-direction:row;align-items:stretch;align-content:stretch;border-top:1px solid ", ";:last-child{border-bottom:1px solid ", ";}"], function (props) {
  return props.prevError || props.currentError ? props.theme.c_foreground_danger : props.theme.c_foreground_gridLines;
}, function (props) {
  return props.prevError || props.currentError ? props.theme.c_foreground_danger : props.theme.c_foreground_gridLines;
});

exports.StyledTableRow = StyledTableRow;